import { ITimespanMetadata } from 'app/extensibility/metadatas/validator/timespan-metadata';
import { IValidatorFactoryService } from './validator-factory.service';
import { IValidatorFn } from 'app/interfaces/IValidatorFn';

import { TimespanValidator } from 'shell-models-lib';

export class TimespanValidatorFactoryService implements IValidatorFactoryService<ITimespanMetadata> {
    // eslint-disable-next-line
    public readonly type: string = 'timespan';
    private timeoutValidation: RegExp = /^(\d+\.)?((0?\d)|(1\d)|(2[0-3]))(:[0-5]?\d){2}$/;

    public createValidatorByMetadata(metadata: ITimespanMetadata): IValidatorFn {
        return this.createValidator(metadata.minimum, metadata.maximum, metadata.errorMessage);
    }

    public createValidator(minimum?: number, maximum?: number, errMsg?: string): IValidatorFn {
        const errorMessage = errMsg != null ? errMsg : stringResources.Pipeline_ElapsedTimeMetricFormattingError;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return (value: any) => {
            if (value == null || value === '') {
                return null;
            } else if (this.timeoutValidation.test(value)) {
                const inSeconds = TimespanValidator.toSeconds(value);
                if ((minimum == null || inSeconds >= minimum) && (maximum == null || inSeconds <= maximum)) {
                    return null;
                }
            }
            return errorMessage;
        };
    }
}
